import { SET_AUTHORIZATION_CONFIG, SET_SECTIONS_TO_SHOW } from '../actions/constants';
const defaultState: any = {
  partsToShow: {},
  sidebarSectionsToShow: {},
};
export default function (state = defaultState, action) {
  switch (action.type) {
    case SET_AUTHORIZATION_CONFIG: {
      return {
        ...state,
        partsToShow: action.data,
      };
    }
    case SET_SECTIONS_TO_SHOW: {
      return {
        ...state,
        sidebarSectionsToShow: action.data,
      };
    }
    default: {
      return state;
    }
  }
}
